// 用户

const Home = () => import("../views/home/home.vue")

export default [
      { path: '/', redirect: '/home'},
      {
        path: '/home',
        alias: '/',
        name: 'home',
        component: Home,
        meta: {
            keepAlive: true,
            id:0
        }
      },
]
